// components/AssinaturaCertificadoA3.tsx
import { Box, Button, Paper, Typography } from '@mui/material';

const AssinaturaCertificadoA3: React.FC = () => {
  const handleSign = (): void => {
    alert('Iniciando processo de assinatura com Certificado A3...');
    // Aqui você chamaria o middleware/extensão para lidar com o A3
  };

  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Typography variant="h6">Assinar com Certificado A3</Typography>
      <Box mt={2}>
        <Typography variant="body2">Conecte seu token ou smartcard antes de assinar.</Typography>
        <Box mt={2}>
          <Button variant="contained" color="primary" onClick={handleSign}>
            Assinar
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default AssinaturaCertificadoA3;
